import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const IcondComponent = React.lazy(() => import("../Components/RootComponents/IcondComponent"));
const IcondPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <IcondComponent />
      </Suspense>
    </Fragment>
  );
};

export default IcondPage;
